import { Navigate, createBrowserRouter } from 'react-router-dom'
import { ProtectedLayout, PublicLayout } from '@/lib/guards'
import { LoginPage } from '@/pages/LoginPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { OnboardingPage } from '@/pages/OnboardingPage'
import { PositionsPage } from '@/pages/PositionsPage'
import { ImportsPage } from '@/pages/ImportsPage'
import { AlertsPage } from '@/pages/AlertsPage'
import { ProfitTakingPage } from '@/pages/ProfitTakingPage'
import { RebalancePage } from '@/pages/RebalancePage'
import { SettingsPage } from '@/pages/SettingsPage'
import { StrategyPage } from '@/pages/StrategyPage'
import { StrategyHistoryPage } from '@/pages/StrategyHistoryPage'
import { StrategyEditPage } from '@/pages/StrategyEditPage'
import { AssetCheckPage } from '@/pages/AssetCheckPage'
import { AssetCheckDetailPage } from '@/pages/AssetCheckDetailPage'
import { EventsPage } from '@/pages/EventsPage'
import { WhatIfPage } from '@/pages/WhatIfPage'

export const router = createBrowserRouter([
  {
    element: <PublicLayout />,
    children: [{ path: '/login', element: <LoginPage /> }],
  },
  {
    element: <ProtectedLayout />,
    children: [
      { path: '/dashboard', element: <DashboardPage /> },
      { path: '/onboarding', element: <OnboardingPage /> },
      { path: '/positions', element: <PositionsPage /> },
      { path: '/imports', element: <ImportsPage /> },
      { path: '/alerts', element: <AlertsPage /> },
      { path: '/events', element: <EventsPage /> },
      { path: '/profit-taking', element: <ProfitTakingPage /> },
      { path: '/rebalance', element: <RebalancePage /> },
      { path: '/settings', element: <SettingsPage /> },
      { path: '/strategy', element: <StrategyPage /> },
      { path: '/strategy/history', element: <StrategyHistoryPage /> },
      { path: '/strategy/:strategyId/edit', element: <StrategyEditPage /> },
      { path: '/asset-check', element: <AssetCheckPage /> },
      { path: '/asset-check/:id', element: <AssetCheckDetailPage /> },
      { path: '/what-if', element: <WhatIfPage /> },
    ],
  },
  { path: '/', element: <Navigate to="/dashboard" replace /> },
  { path: '*', element: <Navigate to="/" replace /> },
])
